import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatindianstyle',
})
export class FormatindianstylePipe implements PipeTransform {
	transform(value: String, args='decimal') {
		let x:any;
		x=this.returnval(value,args.toLowerCase());
		x=x.toString();
		let afterPoint = '';
		if(x.indexOf('.') > 0) {
		   afterPoint = x.substring(x.indexOf('.'),x.length);
		}
		x = Math.floor(x);
		x=x.toString();
		let lastThree = x.substring(x.length-3);
		let otherNumbers = x.substring(0,x.length-3);
		if(otherNumbers != '')
		    lastThree = ',' + lastThree;
		let res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
		let ignoredecimal = res; 
		let decimal = res + afterPoint;
		if(args.toLowerCase() == 'ignoredecimal') {
			return ignoredecimal;
		} else if (args.toLowerCase() == 'inr') {
			let val = +value;
			try {
				val.toLocaleString('i');
			} catch (e) {
			    return val.toLocaleString('en-IN',{style:'currency',currency:'INR'});
			}
			return decimal;
		} else {
			return decimal;
		} 
	}

	returnval(value, arg='decimal'){
		let val = +value;
		let result = (arg=='ignoredecimal') ? val.toFixed() : val.toFixed(2);
		return result;
	}


}



// WEBPACK FOOTER //
// ./src/pipes/formatindianstyle/formatindianstyle.ts